import React from 'react';
import ParticipantInfo from './ParticipantInfo/ParticipantInfo';
import ParticipantTracks from './ParticipantTracks';


export default function Participant({ participant, isLocalParticipant, disableAudio, enableScreenShare, onClick, isSelected}) {
  return (
      <ParticipantInfo participant={participant} isLocalParticipant={isLocalParticipant} onClick={onClick} isSelected={isSelected}>
      <ParticipantTracks participant={participant} disableAudio={disableAudio} enableScreenShare={enableScreenShare} />
    </ParticipantInfo>
  );
}
